import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IPwaInstallInstructionsDialogData } from '../../../interfaces/pwa-install.interfaces';

@Component({
    selector: 'app-pwa-install-instructions-dialog',
    templateUrl: './pwa-install-instructions-dialog.component.html',
    styleUrls: ['./pwa-install-instructions-dialog.component.scss'],
    standalone: false,
})
export class PwaInstallInstructionsDialogComponent {
    public constructor(
        @Inject(MAT_DIALOG_DATA)
        public readonly data: IPwaInstallInstructionsDialogData,
    ) {}
}
